export function isPhoneMode() {
	let ua = window.navigator.userAgent;
	let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
	let webkit = !!ua.match(/WebKit/i);
	let iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

	return iOSSafari;
}
